import React from 'react'
import { useDispatch } from 'react-redux';
import { setModal, setSelectedPost } from '../../../../Features/lensSlice';
import { getCachedMediaUrl } from '../../../../lib/utils/utils';

function PostBox({ image, video, post }) {
    const dispatch = useDispatch();

    const handlePostClick = () => {
        dispatch(setSelectedPost(post));
        dispatch(setModal('post'));
    }

    return (
        <div onClick={handlePostClick} className="size-[240px] max-[1280px]:size-[200px] max-[1152px]:size-[180px] bg-black overflow-hidden rounded-[9px]">
            {image && <img className='hover:opacity-90 size-full object-cover' src={getCachedMediaUrl(image)} alt="" />}
            {video && <video className='hover:opacity-90 size-full object-cover' src={video} />}
        </div>
    );
}

export default PostBox;
